<div class="form-auth forgot" role="form">
  <h2 class="form-auth-heading">Reset Password</h2>
  <div>
    <input type="email" class="form-control user-email" placeholder="Email address" value="" required autofocus autocomplete="username">
    <button class="btn btn-lg btn-primary btn-block" type="submit">Send Reset Email</button>
  </div>
</div>
